import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IWriteupsSharedState } from '..';

export const selectWriteupsLeads = createFeatureSelector<IWriteupsSharedState>(
  'WriteupsSharedState'
);

export const getDetailsForInitiatedWriteup = createSelector(
  selectWriteupsLeads,
  state => state.customerInfo
);
export const getPaymentCallResponse = createSelector(
  selectWriteupsLeads,
  state => state.customerInfo
);

export const getVehicleDetailsForInitiatedWriteup = createSelector(
  selectWriteupsLeads,
  state => state.customerInfo
);

export const getRebateDetailsForInitiatedWriteup = createSelector(
  selectWriteupsLeads,
  state => state.customerInfo
);

export const selectCustomerDetails = createSelector(
  selectWriteupsLeads,
  state => state.customerInfo.customerDetails
);

